import { useEffect, useState } from 'react';
import { FormControl, LinearProgress, MenuItem, TextField, type TextFieldProps } from '@mui/material';
import { getRequestTypes } from '../api/requests';
import type { RequestType } from '../api/types';

interface TypeSelectorProps extends Omit<TextFieldProps, 'onChange'> {
    value: number | '';
    onChange: (typeId: number) => void;
}

export function TypeSelector({ value, onChange, ...props }: TypeSelectorProps) {
    const [list, setList] = useState<RequestType[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        getRequestTypes()
            .then((types) => {
                if (active) setList(types);
            })
            .catch(() => {
                if (active) setList([]);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    // Default: il **primo tipo disponibile**, non un id fisso (l'id `1` potrebbe
    // non esistere o essere stato nascosto). Si applica finché il valore corrente
    // non è un tipo valido della lista.
    useEffect(() => {
        if (list.length > 0 && (value === '' || !list.some((option) => option.type_id === value))) {
            onChange(list[0].type_id);
        }
    }, [list, value, onChange]);

    return (
        <FormControl fullWidth variant="filled">
            <TextField select fullWidth value={value} onChange={(e) => onChange(Number(e.target.value))} {...props}>
                {loading ? (
                    <MenuItem disabled>
                        <LinearProgress className="w-full" />
                    </MenuItem>
                ) : (
                    list.map((option) => (
                        <MenuItem key={option.type_id} value={option.type_id}>
                            {option.type_name}
                        </MenuItem>
                    ))
                )}
            </TextField>
        </FormControl>
    );
}
